/* =====================================================================
   AURA NOIRE · Muestra de regalo del Welcome (v2)
   Archivo del tema: assets/aura-welcome-gift.js (cargado desde layout/theme.liquid)

   QUÉ HACE
   - Reconoce el código único del Welcome (prefijo MUESTRA-, cupón WELCOME_MUESTRA_6EUR de Klaviyo) venga de:
       · el paso 2 del pop-up de Klaviyo (el código aparece en pantalla),
       · un enlace con ?muestra=MUESTRA-XXXX (o ?muestra=1 para recuperar la guardada),
       · /discount/MUESTRA-XXXX (cookie discount_code de Shopify) o el propio carrito,
       · el código ya guardado en este dispositivo (localStorage).
   - Aplica el código al carrito con la API de Shopify (/cart/update.js, campo discount) y añade 1 × "Muestra de regalo"
     (variante 54136341659995), aunque el carrito esté vacío. Sin importe mínimo.
   - Comprueba en el carrito real que Shopify la deja a 0 €. Si no (código caducado, usado o inexistente), la retira,
     quita ese código del carrito y no vuelve a intentarlo con él.
   - Si el cliente quita la muestra, NO se vuelve a añadir sola: en el carrito aparece "Recuperar mi muestra gratis".
   - Si se pierde por otro motivo (carrito nuevo, navegación rápida, error de red), se recupera sola.

   SEGURIDAD
   - El precio 0 € lo pone el descuento de Shopify; aquí no se toca ningún precio.
   - Una sola muestra: deduplicación de líneas y cantidad 1, con bloqueo entre pestañas.
   - Solo se retiran las líneas que marca este script (propiedad oculta _aura_welcome_gift); el resto del carrito,
     los packs de Easy Bundle y los otros códigos de descuento no se modifican.
   - Un error de red o una navegación a mitad de una petición NO se interpreta como "sin stock" ni como código inválido.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__auraWelcomeGift) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.fetch || !window.Promise || !window.URLSearchParams) return;

  var CFG = {
    variantId: 54136341659995,              // Muestra de regalo (única variante)
    codeRe: /\bMUESTRA-[A-Z0-9]{4,24}\b/i,  // códigos únicos de WELCOME_MUESTRA_6EUR (Klaviyo)
    propKey: '_aura_welcome_gift',          // propiedad oculta: línea añadida por este script
    storeKey: 'aura_welcome_gift_v2',       // localStorage: código y estado (sobrevive a cerrar el navegador)
    lockKey: 'aura_welcome_gift_lock',      // localStorage: evita que dos pestañas añadan a la vez
    param: 'muestra',                       // ?muestra=MUESTRA-XXXX  o  ?muestra=1
    codeTtlMs: 45 * 24 * 3600 * 1000,       // se olvida un código a los 45 días (los lotes caducan antes)
    debounceMs: 250,
    lockMs: 8000,
    checkoutWaitMs: 4000
  };

  var STR = Object.assign({
    added: 'Tu muestra gratis está en el carrito',
    view_cart: 'Ver carrito',
    recover_text: 'Tu muestra gratis no está en el carrito.',
    recover_button: 'Recuperar mi muestra gratis',
    recovering: 'Añadiendo…',
    invalid: 'Este código de muestra ya no es válido: ha caducado o ya se ha utilizado.',
    unavailable: 'La muestra gratis no está disponible en este momento. Inténtalo de nuevo más tarde.',
    close: 'Cerrar'
  }, window.auraGiftStrings || {});

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);   // nuestras peticiones no pasan por el observador
  var tabId = Math.random().toString(36).slice(2);
  var running = false, pending = null, timer = null, retryTimer = null, loop = Promise.resolve(), retries = 0;
  var lastCart = null;

  /* ---------- Estado ---------- */
  function now() { return Date.now(); }
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(CFG.storeKey) || '{}');
      return s && typeof s === 'object' ? s : {};
    } catch (e) { return {}; }
  }
  function save(s) { try { localStorage.setItem(CFG.storeKey, JSON.stringify(s)); } catch (e) {} }
  function fresh(code) { return { v: 2, code: code, status: 'active', savedAt: now(), dismissed: false, hadGift: false, cartToken: null }; }
  function norm(code) { return String(code || '').trim().toUpperCase(); }
  function isWelcome(code) { return CFG.codeRe.test(String(code || '')) && norm(code).indexOf('MUESTRA-') === 0; }

  function lock() {
    try {
      var l = JSON.parse(localStorage.getItem(CFG.lockKey) || 'null');
      if (l && l.id !== tabId && l.until > now()) return false;
      localStorage.setItem(CFG.lockKey, JSON.stringify({ id: tabId, until: now() + CFG.lockMs }));
      l = JSON.parse(localStorage.getItem(CFG.lockKey) || 'null');
      return !!(l && l.id === tabId);
    } catch (e) { return true; }   // sin localStorage: sin bloqueo entre pestañas, pero sigue habiendo deduplicación
  }
  function unlock() {
    try {
      var l = JSON.parse(localStorage.getItem(CFG.lockKey) || 'null');
      if (l && l.id === tabId) localStorage.removeItem(CFG.lockKey);
    } catch (e) {}
  }

  /* ---------- Red ---------- */
  function getCart() {
    return origFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  // network: true = la petición no llegó a responder (sin conexión, cancelada por cambio de página...)
  function post(path, body) {
    return origFetch(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { ok: r.ok, status: r.status, data: j, network: false }; });
    }).catch(function () { return { ok: false, status: 0, data: null, network: true }; });
  }

  /* ---------- Carrito ---------- */
  function isGift(line) { return Number(line.variant_id) === CFG.variantId; }
  function isAuto(line) { return !!(line.properties && line.properties[CFG.propKey]); }
  function cartCodes(cart) { return ((cart && cart.discount_codes) || []).map(function (d) { return { code: norm(d.code), applicable: d.applicable }; }); }
  function cartCode(cart, code) {
    var c = norm(code);
    return cartCodes(cart).filter(function (d) { return d.code === c; })[0] || null;
  }
  function welcomeFromCart(cart) {
    var list = cartCodes(cart).filter(function (d) { return isWelcome(d.code); });
    return list.length ? list[list.length - 1].code : null;
  }
  function welcomeFromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    if (!m) return null;
    var v = decodeURIComponent(m[1]).split(',').map(norm).filter(isWelcome);
    return v.length ? v[v.length - 1] : null;
  }
  // Añade el código a los que ya tenga el carrito (no quita ninguno). Devuelve el carrito actualizado o null.
  function applyCode(cart, code) {
    if (cartCode(cart, code)) return Promise.resolve(cart);
    var codes = cartCodes(cart).map(function (d) { return d.code; });
    codes.push(norm(code));
    return post('cart/update.js', { discount: codes.join(',') }).then(function (r) { return r.ok && r.data && r.data.items ? r.data : null; });
  }
  function removeCode(cart, code) {
    var c = norm(code);
    var rest = cartCodes(cart).map(function (d) { return d.code; }).filter(function (x) { return x !== c; });
    if (rest.length === cartCodes(cart).length) return Promise.resolve(cart);
    return post('cart/update.js', { discount: rest.join(',') }).then(function (r) { return r.ok && r.data && r.data.items ? r.data : null; });
  }
  // Retira SOLO las líneas de muestra automáticas. Las claves de línea cambian cuando cambia el reparto de descuentos,
  // así que se relee el carrito antes de cada cambio.
  async function removeAutoLines() {
    for (var n = 0; n < 4; n++) {
      var c = await getCart();
      var autos = ((c && c.items) || []).filter(function (l) { return isGift(l) && isAuto(l); });
      if (!autos.length) return c;
      var r = await post('cart/change.js', { id: autos[0].key, quantity: 0 });
      if (r.network) return null;
    }
    return getCart();
  }
  // Deja como máximo una línea de muestra y con cantidad 1 (solo toca las líneas automáticas).
  async function dedupe(cart) {
    for (var n = 0; n < 4; n++) {
      var gifts = cart.items.filter(isGift);
      var autos = gifts.filter(isAuto);
      var manual = gifts.filter(function (l) { return !isAuto(l); });
      var r = null;
      if (manual.length && autos.length) r = await post('cart/change.js', { id: autos[0].key, quantity: 0 });
      else if (autos.length > 1) r = await post('cart/change.js', { id: autos[1].key, quantity: 0 });
      else if (autos.length === 1 && autos[0].quantity > 1) r = await post('cart/change.js', { id: autos[0].key, quantity: 1 });
      else return { cart: cart, changed: n > 0 };
      if (r.network) return { cart: null, changed: true };
      cart = await getCart();
      if (!cart) return { cart: null, changed: true };
    }
    return { cart: cart, changed: true };
  }

  /* ---------- Evaluación ---------- */
  // opts: { code, explicit (lo pide el cliente: pop-up, enlace, botón), force (añadir aunque la hubiera quitado) }
  async function evaluate(opts) {
    opts = opts || {};
    var st = load();
    var cart = await getCart();
    if (!cart || !cart.items) { scheduleRetry(); return; }

    var found = null;
    if (opts.code) found = norm(opts.code);
    else if (st.code && cartCode(cart, st.code)) found = st.code;
    else if (welcomeFromCart(cart)) found = welcomeFromCart(cart);
    else if (!(st.code && st.status === 'active')) found = welcomeFromCookie();
    if (found && found !== st.code) st = fresh(found);
    if (st.code && st.savedAt && now() - st.savedAt > CFG.codeTtlMs && !found) st = {};
    var mutated = false;

    if (!st.code) {
      // Muestra automática sin ningún código del Welcome: no debe quedarse.
      if (cart.items.some(function (l) { return isGift(l) && isAuto(l); })) {
        if (!lock()) { scheduleRetry(); return; }
        try { cart = await removeAutoLines(); mutated = true; } finally { unlock(); }
      }
      save(st); lastCart = cart; render(st, cart); if (mutated) await refreshUI();
      return;
    }

    if (st.cartToken !== cart.token) { st.cartToken = cart.token; st.hadGift = false; }

    if (st.status === 'invalid') {
      if (opts.explicit) st.notice = 'invalid';
      if (cart.items.some(function (l) { return isGift(l) && isAuto(l); }) || cartCode(cart, st.code)) {
        if (!lock()) { scheduleRetry(); save(st); return; }
        try {
          cart = await removeAutoLines();
          if (cart) cart = await removeCode(cart, st.code);
          mutated = true;
        } finally { unlock(); }
      }
      save(st); lastCart = cart; render(st, cart); if (mutated) await refreshUI();
      return;
    }

    var gifts = cart.items.filter(isGift);
    if (!gifts.length) {
      var removedByCustomer = st.hadGift && !opts.force;
      if (removedByCustomer) { st.dismissed = true; st.hadGift = false; }
      if (opts.force) { st.dismissed = false; st.unavailableUntil = 0; }
      if (st.dismissed || (st.unavailableUntil && st.unavailableUntil > now())) {
        save(st); lastCart = cart; render(st, cart); return;
      }
      if (!lock()) { save(st); scheduleRetry(); return; }
      try {
        var withCode = await applyCode(cart, st.code);
        if (!withCode) { save(st); scheduleRetry(); return; }          // red: se reintenta, sin marcar nada
        cart = withCode;
        if (!cart.items.some(isGift)) {                                 // otra pestaña pudo añadirla entretanto
          var props = {}; props[CFG.propKey] = '1';
          var res = await post('cart/add.js', { items: [{ id: CFG.variantId, quantity: 1, properties: props }] });
          if (res.network) { save(st); scheduleRetry(); return; }      // cambio de página o sin conexión: NO es un rechazo
          if (!res.ok) {
            if (res.status === 422) { st.unavailableUntil = now() + 15 * 60 * 1000; if (opts.explicit) st.notice = 'unavailable'; }
            save(st); lastCart = cart; render(st, cart); return;
          }
          mutated = true;
          if (opts.explicit) st.toast = true;
        }
        cart = await getCart();
        if (!cart) { save(st); scheduleRetry(); return; }
      } finally { unlock(); }
    }

    // Una sola muestra
    if (cart.items.filter(isGift).length > 1 || cart.items.some(function (l) { return isGift(l) && isAuto(l) && l.quantity > 1; })) {
      if (lock()) {
        try { var d = await dedupe(cart); if (d.changed) mutated = true; cart = d.cart; } finally { unlock(); }
        if (!cart) { save(st); scheduleRetry(); return; }
      }
    }

    // Verificación con el carrito real: el descuento de Shopify debe dejarla a 0 €
    var gift = cart.items.filter(isGift)[0];
    if (gift) {
      st.hadGift = true; st.dismissed = false;
      if (Number(gift.final_line_price) > 0) {
        var dc = cartCode(cart, st.code);
        if (!dc) {
          if (lock()) {
            try { var c2 = await applyCode(cart, st.code); if (c2) { cart = c2; mutated = true; } } finally { unlock(); }
          }
          dc = cartCode(cart, st.code);
          gift = cart.items.filter(isGift)[0];
        }
        if (gift && Number(gift.final_line_price) > 0 && dc) {
          // El código está en el carrito y Shopify no lo aplica (o no la deja gratis): caducado, usado o inexistente.
          st.status = 'invalid'; st.hadGift = false; st.toast = false;
          if (opts.explicit) st.notice = 'invalid';
          if (lock()) {
            try {
              cart = await removeAutoLines();
              if (cart) cart = await removeCode(cart, st.code);
              mutated = true;
            } finally { unlock(); }
          }
        } else if (gift && Number(gift.final_line_price) > 0) {
          scheduleRetry();                                                // no se pudo aplicar el código: reintento
        }
      }
    }

    retries = 0;
    save(st); lastCart = cart; render(st, cart);
    if (mutated) await refreshUI();
  }

  // Una sola evaluación a la vez; si llega otra petición mientras tanto, se encadena. Devuelve siempre la promesa
  // del bucle en curso, para que "Pagar pedido" pueda esperar de verdad a que termine.
  function run(opts) {
    if (running) { pending = Object.assign(pending || {}, opts || {}); return loop; }
    running = true;
    loop = (async function () {
      try {
        var o = opts;
        do { pending = null; await evaluate(o); o = pending; } while (o);
      } catch (e) {}
      finally { running = false; }
    })();
    return loop;
  }
  function schedule(opts) { clearTimeout(timer); timer = setTimeout(function () { run(opts); }, CFG.debounceMs); }
  function scheduleRetry() {
    if (retries >= 6) return;
    retries++;
    clearTimeout(retryTimer);
    retryTimer = setTimeout(function () { run(); }, 1500);
  }

  /* ---------- Interfaz (carrito, aviso) ---------- */
  // Repinta burbuja del carrito y, en /cart, líneas y totales con la API de secciones (igual que Dawn).
  async function refreshUI() {
    try {
      var targets = [];
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) targets.push({ el: bubble, section: 'cart-icon-bubble', selector: '.shopify-section' });
      var items = document.getElementById('main-cart-items');
      var footer = document.getElementById('main-cart-footer');
      if (items && items.dataset.id) targets.push({ el: items.querySelector('.js-contents') || items, section: items.dataset.id, selector: '.js-contents' });
      if (footer && footer.dataset.id) targets.push({ el: footer.querySelector('.js-contents') || footer, section: footer.dataset.id, selector: '.js-contents' });
      if (!targets.length) return;
      var wasEmpty = !!document.querySelector('cart-items.is-empty');
      var res = await post('cart/update.js', { sections: targets.map(function (t) { return t.section; }).join(','), sections_url: location.pathname });
      var secs = res && res.data && res.data.sections;
      // En /cart, si pasa de vacío a con productos (o al revés) cambia toda la plantilla: se recarga.
      if (isCartPage() && res && res.data && wasEmpty !== (res.data.item_count === 0)) { location.reload(); return; }
      if (!secs) {
        if (/\/cart\/?$/.test(location.pathname)) location.reload();
        return;
      }
      targets.forEach(function (t) {
        var html = secs[t.section];
        if (!html) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector);
        if (src) t.el.innerHTML = src.innerHTML;
      });
    } catch (e) {}
  }

  function isCartPage() { return /\/cart\/?$/.test(location.pathname); }

  function render(st, cart) {
    try {
      renderCartBox(st, cart);
      if (st.toast) { st.toast = false; save(st); toast(STR.added, true); }
    } catch (e) {}
  }

  function renderCartBox(st, cart) {
    if (!isCartPage()) return;
    var host = document.querySelector('cart-items .page-width') || document.querySelector('cart-items');
    if (!host) return;
    var box = document.getElementById('AuraGiftBox');
    var hasGift = cart && cart.items && cart.items.some(isGift);
    var showRecover = st.code && st.status === 'active' && !hasGift && (st.dismissed || (st.unavailableUntil && st.unavailableUntil > now()));
    var notice = st.notice === 'invalid' ? STR.invalid : st.notice === 'unavailable' ? STR.unavailable : '';
    if (!showRecover && !notice) { if (box) box.hidden = true; return; }
    if (!box) {
      box = document.createElement('div');
      box.id = 'AuraGiftBox';
      box.className = 'aura-gift-box';
      box.setAttribute('role', 'status');
      var anchor = host.querySelector('.title-wrapper-with-link');
      if (anchor && anchor.nextSibling) host.insertBefore(box, anchor.nextSibling); else host.insertBefore(box, host.firstChild);
    }
    box.hidden = false;
    box.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'aura-gift-box__text';
    p.textContent = notice || STR.recover_text;
    box.appendChild(p);
    if (showRecover && !notice) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aura-gift-box__button';
      b.textContent = STR.recover_button;
      b.addEventListener('click', function () {
        b.disabled = true; b.textContent = STR.recovering;
        run({ explicit: true, force: true });
      });
      box.appendChild(b);
    }
    if (notice) { st.notice = ''; save(st); }
  }

  var toastTimer = null;
  function toast(text, withLink) {
    var t = document.getElementById('AuraGiftToast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'AuraGiftToast';
      t.className = 'aura-gift-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '';
    var s = document.createElement('span');
    s.textContent = text;
    t.appendChild(s);
    if (withLink && !isCartPage()) {
      var a = document.createElement('a');
      a.href = root + 'cart';
      a.textContent = STR.view_cart;
      t.appendChild(a);
    }
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'aura-gift-toast__close';
    x.setAttribute('aria-label', STR.close);
    x.textContent = '×';
    x.addEventListener('click', function () { t.classList.remove('is-visible'); });
    t.appendChild(x);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 6000);
  }

  /* ---------- Entradas del código ---------- */
  // 1) Enlace: ?muestra=MUESTRA-XXXX (desde el email) o ?muestra=1 (recuperar la guardada en este dispositivo)
  function fromUrl() {
    try {
      var url = new URL(location.href);
      var v = url.searchParams.get(CFG.param);
      if (v === null) return null;
      url.searchParams.delete(CFG.param);
      history.replaceState(history.state, '', url.pathname + (url.search ? url.search : '') + url.hash);
      if (isWelcome(v)) return { code: norm(v), explicit: true, force: true };
      return { explicit: true, force: true };
    } catch (e) { return null; }
  }

  // 2) Pop-up de Klaviyo: el paso 2 muestra el código único; se aplica en cuanto aparece.
  var klWatch = null, klUntil = 0, klSeen = {};
  // Se lee cada texto por separado (textContent del diálogo entero junta palabras sin espacios: "TUYA.MUESTRA-XXXXSEGUIR").
  var CODE_IN_TEXT = /(?:^|[^A-Z0-9-])(MUESTRA-[A-Z0-9]{4,24})(?![A-Z0-9])/i;
  function scanKlaviyo() {
    var roots = document.querySelectorAll('div[role="dialog"], [class*="klaviyo-form"]');
    for (var i = 0; i < roots.length; i++) {
      var found = null;
      var w = document.createTreeWalker(roots[i], NodeFilter.SHOW_TEXT);
      var n;
      while (!found && (n = w.nextNode())) {
        var m = (n.nodeValue || '').match(CODE_IN_TEXT);
        if (m) found = m[1];
      }
      if (!found) {
        var inputs = roots[i].querySelectorAll('input');
        for (var j = 0; j < inputs.length && !found; j++) {
          var mv = String(inputs[j].value || '').match(CODE_IN_TEXT);
          if (mv) found = mv[1];
        }
      }
      if (found && isWelcome(found) && !klSeen[norm(found)]) {
        klSeen[norm(found)] = true;
        run({ code: found, explicit: true, force: true });
        return true;
      }
    }
    return false;
  }
  function watchKlaviyo(ms) {
    klUntil = Math.max(klUntil, now() + ms);
    if (klWatch) return;
    var pend = null;
    klWatch = new MutationObserver(function () {
      if (now() > klUntil) { klWatch.disconnect(); klWatch = null; return; }
      clearTimeout(pend); pend = setTimeout(scanKlaviyo, 150);
    });
    klWatch.observe(document.body, { childList: true, subtree: true, characterData: true });
    scanKlaviyo();
  }
  window.addEventListener('klaviyoForms', function (e) {
    var type = e && e.detail && e.detail.type;
    if (type === 'open' || type === 'embedOpen') watchKlaviyo(10 * 60 * 1000);
    if (type === 'submit' || type === 'stepSubmit' || type === 'viewedStep') watchKlaviyo(5 * 60 * 1000);
  });

  // 3) Cualquier cambio de carrito o de código (tema, ficha, colección, Easy Bundle, /discount/)
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)|\/discount\//;
  window.fetch = function (input) {
    var p = origFetch.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(url)) p.then(function () { schedule(); }, function () {});
    } catch (e) {}
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  var xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__auraUrl = String(u || ''); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (CART_RE.test(this.__auraUrl || '')) this.addEventListener('loadend', function () { schedule(); });
    return xs.apply(this, arguments);
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (!ev || ev.source !== 'external-refresh') schedule(); });
  }

  // 4) Pagar pedido: si la muestra está pendiente de añadirse, se espera a que entre (máx. 4 s) antes de ir al checkout.
  var passCheckout = false;
  function needsGift() {
    var st = load();
    if (!st.code || st.status !== 'active' || st.dismissed) return false;
    if (st.unavailableUntil && st.unavailableUntil > now()) return false;
    if (running) return true;
    return !(lastCart && lastCart.items && lastCart.items.some(function (l) { return isGift(l) && Number(l.final_line_price) === 0; }));
  }
  document.addEventListener('click', function (e) {
    if (passCheckout) return;
    var el = e.target && e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!el || !needsGift()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var go = function () {
      passCheckout = true;
      if (el.tagName === 'A') { location.href = el.href; return; }
      var form = el.form || el.closest('form');
      if (form) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'checkout'; h.value = '1';
        form.appendChild(h);
        HTMLFormElement.prototype.submit.call(form);
      } else { location.href = root + 'checkout'; }
    };
    var done = false;
    var finish = function () { if (!done) { done = true; go(); } };
    setTimeout(finish, CFG.checkoutWaitMs);
    run().then(finish, finish);
  }, true);

  /* ---------- Arranque ---------- */
  function boot() {
    var u = fromUrl();
    var st = load();
    var hasCart = /(^|;\s*)cart=/.test(document.cookie);
    if (u) { run(u); return; }
    if (st.code || hasCart || welcomeFromCookie()) schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });

  window.__auraWelcomeGift = { cfg: CFG, run: run, state: load, needsGift: needsGift };
})();
